const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Typography, Grid2 } from '@mui/material';

class Title extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '' };
    }

    render() {
        const { t, i18n } = this.props;

        let end_time = this.props.short.end_time;
        let start_time = this.props.short.start_time;

        return (
            <Grid2 container className="wpvc_contest_title">
                <Typography
                    variant="h5"
                    className="wpvc_grid_header"
                >
                    {this.props.short.title}
                </Typography>
            </Grid2>
        )

    }
}

export default connect()(withTranslation("translations")(Title));
